var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.06 6.52L11.98 7.44L2.92 16.5H2V15.58L11.06 6.52ZM14.66 0.5C14.41 0.5 14.15 0.6 13.96 0.79L12.13 2.62L15.88 6.37L17.71 4.54C18.1 4.15 18.1 3.52 17.71 3.13L15.37 0.79C15.17 0.59 14.92 0.5 14.66 0.5ZM11.06 3.69L0 14.75V18.5H3.75L14.81 7.44L11.06 3.69Z",
    fill: "#606060",
    fillOpacity: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.e73728cb73e46ce6d1114caf855c42ce.svg";
export { ForwardRef as ReactComponent };